export default {
  setCurrent: (state, payload) => (state.current = payload)
};
